import { type ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit'

import { setLoading } from '../thunks/setLoading.ts'

export interface InitialCoreState {
	loading: boolean
}

const initialState: InitialCoreState = {
	loading: true,
}

const coreSlice = createSlice({
	name: 'core',
	initialState,
	reducers: {},
	extraReducers: (builder: ActionReducerMapBuilder<InitialCoreState>) => {
		builder.addCase(setLoading.fulfilled, (state, action) => {
			state.loading = action.payload
		})
	},
})

export default coreSlice.reducer
